import pick from 'lodash/fp/pick.js';
import mapValues from 'lodash/mapValues.js';
const pruneQuery = pick(['args', 'resolver', 'shape', 'description']);
const migrate = async (_, projectSchema) => {
    return {
        ...projectSchema,
        queries: mapValues(projectSchema.queries, pruneQuery),
        mutations: mapValues(projectSchema.mutations, pruneQuery),
        schemaVersion: '3.18.1'
    };
};
export default migrate;
